import React, { Component } from 'react';
import TopMenu from '../TopMenu';

class Header extends Component {


  render() {

    // const { isPageHome } = this.props.appStore;
    // const { isMobile } = this.props.browserStore;

    return (
        <TopMenu />
    )
  }

}


export default Header;



// WEBPACK FOOTER //
// /src/components/layout/Header.js